/**
 * Typography configuration for Material-UI v7 theme
 * Migrated from legacy Gatsby theme with Roboto + Quicksand fonts
 */

/**
 * Font families configuration
 */
export const fontFamily = {
  primary: ['Roboto', 'sans-serif'].join(','),
  secondary: ['Quicksand', 'sans-serif'].join(','),
  monospace: ['Monaco', 'Menlo', 'Ubuntu Mono', 'monospace'].join(','),
};

/**
 * Base typography configuration
 */
export const baseTypography = {
  fontFamily: [
    'Roboto',
    'Quicksand',
    'sans-serif',
  ].join(','),

  // Base font size and scaling
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,

  // Line height for readability
  lineHeight: 1.6,
};

/**
 * Typography variants configuration for MUI v7
 */
export const typography = {
  ...baseTypography,

  // Main headings with Roboto bold - Aligned with legacy configuration
  h1: {
    fontFamily: fontFamily.primary,
    fontWeight: 900,
    fontSize: '4.3rem',
    marginBottom: 10,
  },

  h2: {
    fontFamily: fontFamily.primary,
    fontWeight: 900,
    fontSize: '3.5rem',
    marginBottom: 10,
  },

  h3: {
    fontFamily: fontFamily.primary,
    fontWeight: 900,
    fontSize: '2rem',
    marginBottom: 15,
  },

  h4: {
    fontFamily: fontFamily.primary,
    fontWeight: 600,
    fontSize: '1.4rem',
    marginBottom: 10,
  },

  h5: {
    fontFamily: fontFamily.primary,
    fontWeight: 600,
    fontSize: '1.5rem',
    marginBottom: 15,
  },

  // Subtitle with Quicksand - Aligned with legacy
  h6: {
    fontFamily: fontFamily.secondary,
    fontSize: '1.2rem',
  },

  // Body text - Aligned with legacy configuration
  body1: {
    textAlign: 'justify'
  },

  body2: {
    fontWeight: 300
  },

  // UI elements - Aligned with legacy
  button: {
    fontWeight: 700,
    fontFamily: fontFamily.secondary,
  },

  caption: {
    // #757575 (4.61:1 on white) instead of #7d7d7d (4.12:1) to meet WCAG AA 1.4.3
    color: '#757575'
  },

  overline: {
    fontFamily: fontFamily.secondary,
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },

  // Custom variants for climate application
  subtitle1: {
    fontFamily: fontFamily.secondary,
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },

  subtitle2: {
    fontFamily: fontFamily.secondary,
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
};

/**
 * Responsive typography configuration
 */
export const responsiveTypography = {
  // Breakpoints for responsive font sizes
  breakpoints: ['sm', 'md', 'lg'],

  // Font scaling factors
  factor: 2,

  // Disable responsive fonts for specific variants if needed
  disableAlign: false,

  // Custom responsive rules
  variants: {
    h1: {
      fontSize: {
        xs: '2.5rem',
        sm: '3rem',
        md: '3.5rem',
        lg: '4.3rem',
      },
    },
    h2: {
      fontSize: {
        xs: '2rem',
        sm: '2.5rem',
        md: '3rem',
        lg: '3.5rem',
      },
    },
    h3: {
      fontSize: {
        xs: '1.5rem',
        sm: '1.75rem',
        md: '2rem',
      },
    },
  },
};

export default typography;
